export default function BrandMark({
  className = "h-9 w-9 rounded-md",
  alt = "AIROBOTCAMSTUDIO official logo",
  testid,
}) {
  return (
    <img
      src="/assets/founder/airobotcamstudio-logo.png"
      alt={alt}
      width={1254}
      height={1254}
      loading="lazy"
      data-testid={testid}
      className={`shrink-0 ${className}`}
    />
  );
}
